import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class Floors extends Component {
  render() {
    return (
      <EntityList apiRoute='api/floors' title='Remorque - Planchers' editTitle='Plancher' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default Floors;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/floors.js
 **/